import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["filtersBtn", "mdFilterColumn"]

    connect() {
        this.checkScreenSize()
        this.boundCheckScreenSize = this.checkScreenSize.bind(this)
        window.addEventListener('resize', this.boundCheckScreenSize)
    }

    disconnect() {
        window.removeEventListener('resize', this.boundCheckScreenSize)
    }

    checkScreenSize() {

        if (window.innerWidth >= 768) {
            this.mdClose()
        }
    }


    mdClose() {
        this.mdFilterColumnTarget.style.display = "none"
    }

    mdShow() {
        window.scrollTo(0, 0)

        this.mdFilterColumnTarget.style.display = "block"
    }
}